import { Loader } from "components/elements";
import {
  PageContent,
  PageHeader,
  Section,
  TabContent,
  Subsection,
} from "components/layout";
import { TiVoDeviceOemWarning } from "hooks/tivoDevices";

import { TEXTS } from "../constants";
import { OemWarnings } from "./OemWarnings";
import { TiVoDeviceTab, TiVoDeviceTabs } from "./TiVoDeviceTabs";

interface TiVoDeviceDetailsProps {
  title: string;
  header: string;
  tabs: TiVoDeviceTab[];
  fields: {
    label: string;
    value?: string;
  }[];
  loading: boolean;
  warnings?: TiVoDeviceOemWarning[];
}

export function TiVoDeviceDetails({
  title,
  tabs,
  header,
  fields,
  loading,
  warnings,
}: TiVoDeviceDetailsProps) {
  return (
    <>
      <PageHeader>{title}</PageHeader>
      <PageContent>
        <TiVoDeviceTabs tabs={tabs} />
        <TabContent>
          <Section header={header}>
            {loading ? (
              <Loader />
            ) : (
              fields.map((field) => (
                <Subsection header={field.label} key={field.label}>
                  {field.value || TEXTS.NO_VALUE}
                </Subsection>
              ))
            )}
          </Section>
        </TabContent>
        <OemWarnings warnings={warnings} />
      </PageContent>
    </>
  );
}
